export const ALL_VALUE = 'all';

// Refusal from the ARTSHIFT share-right gate on POST /lessons/{id}/students. Thrown as a
// CustomException, so it arrives as error.error_code at the top level - NOT inside error.errors[],
// which stays empty for this class of error.
export const NO_ARTSHIFT_USAGE_RIGHT = 'MFS-E-LEARNING-ADMIN-LESSON-37';

export const DEFAULT_ALL_OPTION = (t: any) => [
  {
    label: t('lesson_student.all'),
    value: ALL_VALUE,
    info: {
      full_name_kanji: t('lesson_student.all'),
      email: t('lesson_student.all'),
      phone_number: t('lesson_student.all'),
      mentor: {
        email: t('lesson_student.all'),
      },
      value: ALL_VALUE,
    },
  },
];

export const DEFAULT_ALL_COACH_OPTION = (t: any) => [
  {
    label: t('lesson_coach.all'),
    value: ALL_VALUE,
    info: {
      full_name_kanji: t('lesson_coach.all'),
      email: t('lesson_coach.all'),
      phone_number: t('lesson_coach.all'),
      value: ALL_VALUE,
    },
  },
];

export const AT_LEAST_ONE_OPTION = 'AT_LEAST_ONE_OPTION';
export const ALWAYS_SHOW_DEFAULT = 'ALWAYS_SHOW_DEFAULT';
